(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/reducers/chat-queued-messages-reducer.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/reducers/chat-queued-messages-reducer.js');

'use strict';

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  CHAT_PAGE_LOAD_INIT,
  CHAT_PAGE_LOAD_SUCCESS,
  CHAT_SEND_MESSAGE_INIT,
  CHAT_SEND_MESSAGE_INIT_RETRY,
  CHAT_SEND_MESSAGE_SUCCESS,
  CHAT_SEND_MESSAGE_FAILURE,
  CHAT_RECEIVE_MESSAGE,
  CHAT_DELETE_QUEUED_MESSAGE,
  CHAT_PURGE_ROOM
} = svs.components.chat.chatData.actions;
const chatQueuedMessagesReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  const roomId = action.roomId;
  switch (action.type) {
    case CHAT_PAGE_LOAD_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread({}, state[roomId])
      });
    case CHAT_DELETE_QUEUED_MESSAGE:
      {
        const _state$roomId = state[roomId],
          _ref = "".concat(action.localId),
          {
            [_ref]: deleteMe
          } = _state$roomId,
          remainingQueuedMessages = _objectWithoutProperties(_state$roomId, [_ref].map(_toPropertyKey));
        return _objectSpread(_objectSpread({}, state), {}, {
          [roomId]: remainingQueuedMessages
        });
      }
    case CHAT_SEND_MESSAGE_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [action.localId]: {
            isMe: true,
            localId: action.localId,
            name: action.name,
            message: action.message,
            timestamp: action.timestamp,
            error: null
          }
        })
      });
    case CHAT_SEND_MESSAGE_INIT_RETRY:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [action.localId]: _objectSpread(_objectSpread({}, state[roomId][action.localId]), {}, {
            error: null
          })
        })
      });
    case CHAT_SEND_MESSAGE_SUCCESS:
      {
        const localMessage = state[roomId][action.localId];
        if (localMessage) {
          const updatedMsg = _objectSpread(_objectSpread({}, state[roomId][action.localId]), {}, {
            id: action.messageId
          });
          const updatedQueuedMessages = _objectSpread(_objectSpread({}, state[roomId]), {}, {
            [action.messageId]: updatedMsg
          });
          delete updatedQueuedMessages[action.localId];
          return _objectSpread(_objectSpread({}, state), {}, {
            [roomId]: updatedQueuedMessages
          });
        }
        return state;
      }
    case CHAT_SEND_MESSAGE_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [action.localId]: _objectSpread(_objectSpread({}, state[roomId][action.localId]), {}, {
            error: action.error
          })
        })
      });
    case CHAT_RECEIVE_MESSAGE:
      {
        const messageId = action.messageData.id;
        const clientToken = action.clientToken;
        const roomQueue = state[roomId] || {};
        if (roomQueue[messageId] || roomQueue[clientToken]) {
          const _state$roomId2 = state[roomId],
            {
              [messageId]: deleteMe,
              [clientToken]: deleteMe2
            } = _state$roomId2,
            saveUs = _objectWithoutProperties(_state$roomId2, [messageId, clientToken].map(_toPropertyKey));
          return _objectSpread(_objectSpread({}, state), {}, {
            [roomId]: saveUs
          });
        }
        return state;
      }
    case CHAT_PURGE_ROOM:
      {
        const _ref2 = "".concat(action.roomId),
          {
            [_ref2]: deleteMe
          } = state,
          saveUs = _objectWithoutProperties(state, [_ref2].map(_toPropertyKey));
        return saveUs;
      }
    case CHAT_PAGE_LOAD_SUCCESS:
      {
        const purgedQueue = _objectSpread({}, state[roomId]);
        if (action.messages) {
          action.messages.map(msg => msg.id).forEach(id => delete purgedQueue[id]);
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          [roomId]: purgedQueue
        });
      }
    default:
      return state;
  }
};
setGlobal('svs.components.chat.chatData.reducers.chatQueuedMessagesReducer', chatQueuedMessagesReducer);

 })(window);